'use-strict'
import React from "react";
import {
  HasRole,
} from 'react-role-permission';
import app from '../../data/base';
import moment, {normalizeUnits} from 'moment';
import {

  Media,

} from "reactstrap";

/**
 *
 *
 * @param {*} inputobject
 * String nome
 * Date data
 * String gruppo
 * String descrizione
 * String tipo
 */

const validateRequiredField = (inputvalue) => {
  if (inputvalue == null || inputvalue == '') {
    return false;
  } else
    return true;
}

const validateSession = (inputobject, file) => {
  const result = [];
  if (!validateRequiredField(inputobject.nome)) {
    result.push({field: 'Nome', error: 'Campo obbligatorio'});
  }
  // if (!validateRequiredField(inputobject.descrizione)) {
  //   result.push({field: 'Descrizione', error: 'Campo obbligatorio'});
  // }
  // if (!validateRequiredField(inputobject.tipo)) {
  //   result.push({field: 'Tipo', error: 'Campo obbligatorio'});
  // }
  if (!validateRequiredField(inputobject.gruppo)) {
    result.push({field: 'Gruppo', error: 'Campo obbligatorio'});
  }
  if (!validateRequiredField(inputobject.data)) {
    result.push({field: 'Data', error: 'Campo obbligatorio'});
  }
  console.log(file);

  if (!file?.videoUrl && !inputobject.id) {
    result.push({field: 'Video', error: 'Aggiungere file video alla sessione'});
  }


  return result;

}


const saveSession = async (inputobject) => {
  try {

    // if(validateForm()){
    const body = {
      description: inputobject.descrizione,
      name: inputobject.nome,
      linkVideo: inputobject.linkVideo,
      linkPdf: inputobject.linkPdf,
      //linkTrascrizione: inputobject.linkTrascrizione || "",
      //idSpeakerGroup: inputobject.gruppo_relatori,
      idGroup: inputobject.gruppo,
      timestamp: new Date(inputobject.data).getTime(),
      idStato: 1,
      deleted: false,
      timenote: inputobject.timenote || "",
      numeroSessione : inputobject.numeroSessione,
      trascrizioni: inputobject.trascrizioni
    };
    if (inputobject.id) body.id = inputobject.id;
    console.debug('Saving in session');
    console.log(body);
    console.debug(body);


    const response = await app.methods.callserver('api/session', 'POST', null, JSON.stringify(body), true);
    const data = await response.json();
    console.debug('Saved in session')
    console.debug(data);
    return data

  } catch (err) {
    console.error(err);
    throw err
  }
}


const destroySession = async (session_id) => {
  try {
    console.log("destroySession: ", session_id);
    const response = await app.methods.callserver('api/session/' + session_id, 'DELETE', null, null, true);
    await response.text();
    console.debug(response);
    return true;
  } catch (err) {
    console.log('Error during destroySession');
    console.log(err);
    return false;
  }     
}

const destroyElasticSession = async (sessionDTO) => {
  try {
    console.log("destroyElasticSession: ", sessionDTO);

    const response = await app.methods.callserver('api/audioma/v1/delete', 'POST', null, JSON.stringify(sessionDTO), true);
    console.log(response);
    return true;
  } catch (err) {
    console.log('Error during destroyElasticSession');
    console.log(err);
    return false;
  }     
}

const updateSession = async (session) => {
  console.log("input Session: ", session);
  const body = {
    ...session,
  }
  console.log('sessionDTO: ', body);
  const response = await app.methods.callserver('api/session', 'POST', null, JSON.stringify(body), true);
  const data = await response.json();
  // do I need data?
  return data;
}

/**
 *
 * @deprecated
 */
const uploadFile = async (file) => {
  try {
    const body = {
      //tobedef
    }

    const response = await app.methods.callserver('api/session/upload', 'POST', null, body, true);
    if (response.status == '200') {
      const data = response.json();
      if (data['id'])
        return true;
      else
        return false;
    } else {
      return false;
    }
    // }else{
    //     return false;
    // }

  } catch (err) {
    console.log('Error during saveSession');
    console.log(err);
    return false;
  }
}

const loadSessioni = async (id) => {
  //return loadsessioniMockup();
  try {
    const response = await app.methods.callserver('api/session' + (id ? '/' + id : ''), 'GET', null, null, true);
    if (response.status == '200') {
      const data = await response.json();
      if (Array.isArray(data)) {
        return data;
      } else if (id) {
        return data;
      } else {
        return false;
      }

    } else {
      return false;
    }

  } catch (err) {
    console.log('Error during loadSessioni');
    console.log(err);
    return false;
  }
}

const loadsessioniMockup = async (filterrows) => {
  'use-strict'
  try {
    //return await app.methods.callserver('session' + filterrows ? '?rowcount=' + filterrows + '&order=desc' : '','GET');//

    return [{
      "id": 1,
      "nome": "Sessione Mock 1",
      "data": moment().format('DD/MM/YYYY h:mm:ss'),
      "stato": "creata",
      "tipo": <Media
        className="img-fluid"
        src='/images/video_icon_sm.png'
        alt=""
      />,
      "gruppo": "Gruppo1"
    },
      {
        "id": 1,
        "nome": "Sessione Mock 2",
        "data": moment().format('DD/MM/YYYY h:mm:ss'),
        "stato": "creata",
        "tipo": <Media
          className="img-fluid"
          src='/images/video_icon_sm.png'
          alt=""
        />,
        "gruppo": "Gruppo1"
      }, {
        "id": 1,
        "nome": "Sessione Mock 3",
        "data": moment().format('DD/MM/YYYY h:mm:ss'),
        "stato": "creata",
        "tipo": <Media
          className="img-fluid"
          src='/images/video_icon_sm.png'
          alt=""
        />,
        "gruppo": "Gruppo1"
      }, {
        "id": 1,
        "nome": "Sessione Mock 4",
        "data": moment().format('DD/MM/YYYY h:mm:ss'),
        "stato": "creata",
        "tipo": <Media
          className="img-fluid"
          src='/images/video_icon_sm.png'
          alt=""
        />,
        "gruppo": "Gruppo1"
      }, {
        "id": 1,
        "nome": "Sessione Mock 5",
        "data": moment().format('DD/MM/YYYY h:mm:ss'),
        "stato": "creata",
        "tipo": <Media
          className="img-fluid"
          src='/images/video_icon_sm.png'
          alt=""
        />,
        "gruppo": "Gruppo1"
      }]
  } catch (err) {
    console.log('Error during loadsessioni');
    console.log(err);
    throw err;
  }

}

function sessionToRecorderSession(session, json = false) {
  const {
    id,
    idGroup,
    linkVideo,
    linkTrascrizione,
    name,
    description,
    timestamp,
    numeroSessione,
    content
  } = session;

  const recorderSession = {
    groupId: idGroup, //localStorage.getItem('grp'),
    ownerId: localStorage.getItem('id'),
    multimediaFileURL: linkVideo,
    transcriptionFileURL: linkTrascrizione || 'MOCKED_URL',
    name,
    description,
    date: moment(timestamp).format('DD/MM/YYYY'),
    privacyType: 'GROUP',
    tags: ['MOCKED_TAGS'],
    content : content ? content : 'MOCKED_CONTEND',
    typeTags: [
      {
        type: 'ID',
        tags: [
          String(id)
        ]
      },
      {
        type: 'NUMEROSESSIONE',
        tags: [
          String(numeroSessione)
        ]
      }
    ]
  }
  if (!json) {
    return JSON.stringify(recorderSession);
  } else return recorderSession
// deleted: false
  // description: "con video"
  // id: 7
  // idGroup: 2
  // idStato: 1
  // linkTrascrizione: ""
  // linkVideo: "https://pvclouddev.blob.core.windows.net/test/8c5668fa-23f9-4c57-a3ab-6f39af470875.mp4"
  // name: "con video"
  // timenote: ""
  // timestamp: 1635977878602
  // trascrizione: null

//  {
//   "groupId": "string",
//   "ownerId": "string",
//   "multimediaFileURL": "https://...",
//   "transcriptionFileURL": "https://...",
//   "thumbnailFileURL": "https://...",
//   "name": "string",
//   "description": "string",
//   "content": "string",
//   "date": "31/12/2020",
//   "privacyType": "PUBLIC",
//   "tags": [
//     "string"
//   ],
//   "typeTags": [
//     {
//       "type": "string",      <--- "ID"
//       "tags": [
//         "string"             <----{id}
//       ]
//     }
//   ]
// }
}

/**
 *
 * @param {"typeTags": [    {      "type": "string",        "tags": [        "string"                                 ]    }  ]} typeTagsFilter
 * @returns listsessions
 */
const queryElasticSearch = async (typeTagsFilter, ispublic) => {

  try {
    const response = await app.methods.callserver(ispublic ? 'api/audioma/v1/public/query' : 'api/audioma/v1/query', 'POST', null, typeTagsFilter, true);
    console.log(response)
    if (response.status > 199 && response.status < 300) {
      return await response.json();
    } else return Error(response.statusText)
  } catch (err) {
    console.log('[api/audioma/v1/query] Error on queryElasticSearch()');
    console.error(err);
    throw err;
  }
}

const sessions = {
  auth: {
    onAuthStateChanged: app.auth.onAuthStateChanged
  },
  methods: {
    callserver: app.methods.callserver,
    saveSession: saveSession,
    updateSession: updateSession,
    destroySession: destroySession,
    destroyElasticSession: destroyElasticSession,
    loadSessioni: loadSessioni,
    loadsessioniMockup: loadsessioniMockup,
    validateSession: validateSession,
    queryElasticSearch,
  },
  parser: {
    sessionToRecorderSession
  }
};
export default sessions;
